import { RouteType } from 'types/RouteType';

const qualityControlHubRoute: RouteType = {
  name: 'QC Dashboard',
  path: '/quality-control',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Quality Control',
      component: () => import('./QualityControlHub.Header'),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import('./QualityControlHub.Body'),
    },
  },
  group: 'Quality Control',
  requiresAuth: true,
  requiresPermission: false,
  channels: ['quality-control'],
};

export default qualityControlHubRoute;
